import type { SkillDefinition } from "../skills";

export interface SkillPresetGroup {
  id: string;
  name: string;
  icon: string;
  skills: SkillDefinition[];
}

export const SKILL_PRESETS: SkillPresetGroup[] = [
  {
    id: "programming",
    name: "Programmiersprachen",
    icon: "\u{1F4BB}",
    skills: [
      { id: "php", emoji: "\u{1F418}", name: "PHP", description: "PHP-Entwicklung" },
      { id: "rust", emoji: "\u{1F980}", name: "Rust", description: "Rust-Entwicklung" },
      { id: "typescript", emoji: "\u{1FAD0}", name: "TypeScript", description: "TypeScript-Entwicklung" },
      { id: "python", emoji: "\u{1F40D}", name: "Python", description: "Python-Entwicklung" },
      { id: "go", emoji: "\u{1F439}", name: "Go", description: "Go-Entwicklung" },
      { id: "kotlin_java", emoji: "\u2615", name: "Java / Kotlin", description: "Java/Kotlin-Entwicklung" },
      { id: "csharp", emoji: "\u{1F7E3}", name: "C#", description: "C#/.NET-Entwicklung" },
      { id: "ruby", emoji: "\u{1F48E}", name: "Ruby", description: "Ruby-Entwicklung" },
      { id: "swift", emoji: "\u{1F426}", name: "Swift", description: "Swift-Entwicklung" },
      { id: "cpp", emoji: "\u2699\uFE0F", name: "C / C++", description: "C/C++-Entwicklung" },
    ],
  },
  {
    id: "frontend",
    name: "Frontend / UI",
    icon: "\u{1F3A8}",
    skills: [
      { id: "react", emoji: "\u269B\uFE0F", name: "React", description: "React-Entwicklung" },
      { id: "vue", emoji: "\u{1F7E2}", name: "Vue", description: "Vue.js-Entwicklung" },
      { id: "angular", emoji: "\u{1F170}\uFE0F", name: "Angular", description: "Angular-Entwicklung" },
      { id: "css_design", emoji: "\u{1F3A8}", name: "CSS / Design", description: "CSS und visuelles Design" },
      { id: "accessibility", emoji: "\u267F", name: "Accessibility", description: "Barrierefreiheit" },
      { id: "react_native", emoji: "\u{1F4F1}", name: "React Native", description: "React Native Mobile-Entwicklung" },
      { id: "flutter", emoji: "\u{1F98B}", name: "Flutter", description: "Flutter Mobile-Entwicklung" },
    ],
  },
  {
    id: "infrastructure",
    name: "Infrastructure / DevOps",
    icon: "\u{1F3D7}\uFE0F",
    skills: [
      { id: "docker_k8s", emoji: "\u{1F433}", name: "Docker / Kubernetes", description: "Container-Orchestrierung" },
      { id: "cicd", emoji: "\u{1F504}", name: "CI/CD", description: "Continuous Integration und Deployment" },
      { id: "cloud", emoji: "\u2601\uFE0F", name: "Cloud (AWS/GCP/Azure)", description: "Cloud-Plattformen" },
      { id: "monitoring", emoji: "\u{1F4E1}", name: "Monitoring", description: "Monitoring und Observability" },
      { id: "networking", emoji: "\u{1F310}", name: "Networking", description: "Netzwerk-Infrastruktur" },
      { id: "linux", emoji: "\u{1F427}", name: "Linux", description: "Linux-Administration" },
    ],
  },
  {
    id: "projectmanagement",
    name: "Projektmanagement",
    icon: "\u{1F4CB}",
    skills: [
      { id: "planning", emoji: "\u{1F5C2}\uFE0F", name: "Planung & Struktur", description: "Systematische Planung und Strukturierung" },
      { id: "leadership", emoji: "\u{1F451}", name: "Personalfuehrung", description: "Fuehrung und Motivation von Teams" },
      { id: "scrum_agile", emoji: "\u{1F3C3}", name: "Scrum / Agile", description: "Agile Methoden und Scrum" },
      { id: "stakeholder", emoji: "\u{1F91D}", name: "Stakeholder-Management", description: "Kommunikation mit Stakeholdern" },
      { id: "risk", emoji: "\u26A0\uFE0F", name: "Risikomanagement", description: "Identifikation und Management von Risiken" },
      { id: "strategy", emoji: "\u265F\uFE0F", name: "Strategische Planung", description: "Kurz- und langfristige strategische Planung" },
    ],
  },
  {
    id: "data",
    name: "Data / Analytics",
    icon: "\u{1F4CA}",
    skills: [
      { id: "data_science", emoji: "\u{1F4CA}", name: "Data Science", description: "Datenanalyse und Statistik" },
      { id: "bi_reporting", emoji: "\u{1F4C8}", name: "BI / Reporting", description: "Business Intelligence und Reporting" },
      { id: "sql", emoji: "\u{1F5C4}\uFE0F", name: "SQL", description: "SQL und Datenbankdesign" },
      { id: "ml", emoji: "\u{1F9E0}", name: "Machine Learning", description: "Machine Learning und KI" },
      { id: "data_engineering", emoji: "\u{1F527}", name: "Data Engineering", description: "Daten-Pipelines und ETL" },
    ],
  },
  {
    id: "design",
    name: "Design",
    icon: "\u270F\uFE0F",
    skills: [
      { id: "ui_design", emoji: "\u{1F5BC}\uFE0F", name: "UI Design", description: "Gestaltung von Benutzeroberflaechen" },
      { id: "ux_research", emoji: "\u{1F50D}", name: "UX Research", description: "Nutzerforschung und Usability" },
      { id: "prototyping", emoji: "\u{1F4D0}", name: "Prototyping", description: "Erstellung von Prototypen" },
      { id: "brand_design", emoji: "\u{1F3F7}\uFE0F", name: "Brand Design", description: "Markengestaltung und Corporate Design" },
    ],
  },
  {
    id: "qa",
    name: "QA / Testing",
    icon: "\u{1F9EA}",
    skills: [
      { id: "manual_testing", emoji: "\u{1F50E}", name: "Manuelles Testing", description: "Manuelles und exploratives Testen" },
      { id: "test_automation", emoji: "\u{1F916}", name: "Testautomatisierung", description: "Automatisierte Tests und Frameworks" },
      { id: "performance_testing", emoji: "\u26A1", name: "Performance Testing", description: "Last- und Performance-Tests" },
      { id: "security_testing", emoji: "\u{1F6E1}\uFE0F", name: "Security Testing", description: "Sicherheitstests und Penetration Testing" },
    ],
  },
  {
    id: "operations",
    name: "Operations / Soft Skills",
    icon: "\u{1F939}",
    skills: [
      { id: "incident_response", emoji: "\u{1F692}", name: "Incident Response", description: "Reaktion bei Systemausfaellen" },
      { id: "availability", emoji: "\u23F0", name: "Verfügbarkeit / Bereitschaft", description: "Bereitschaft fuer Einsätze" },
      { id: "mentoring", emoji: "\u{1F393}", name: "Mentoring", description: "Anleitung und Wissenstransfer" },
      { id: "documentation", emoji: "\u{1F4DD}", name: "Dokumentation", description: "Technische Dokumentation" },
    ],
  },
];
